import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  box-sizing: border-box;
  width: auto;
  max-width: ${({ $hasComments, $commentSidebarWidth }) => ($hasComments ? `calc(100% - ${$commentSidebarWidth}px)` : "98%")};
  padding: 0 40px;
  margin-top: 22px;

  input,
  textarea {
    padding: 0;
    border: none;
    width: 100%;
    font-size: 36px;
    font-weight: 700;
    color: var(--grey-0);
    background-color: transparent;
    resize: none;

    &.untitled {
      color: var(--grey-2);
    }
  }

  textarea {
    max-width: 98%;
  }

  &.chapter-glue-beta {
    padding: 0;
    margin-top: 0;

    /* Center the inner AutoExpandTextarea wrapper and apply vertical offset */
    > div {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: ${(props) => (props.isSingleLine ? "center" : "flex-start")};
      justify-content: center;
      /* Avoid translating the wrapper to prevent jumps when wrapping to multiline */
      transform: none;
    }

    input,
    textarea {
      font-size: 24px;
    }
  }
`;
